import { defineComponent as _defineComponent } from 'vue'
import { inject } from "vue";
import ReplyContents from "@/components/communityTalk/reply/ReplyContents.vue";
import ReplyResponseButton from "@/components/communityTalk/reply/ReplyResponseButton.vue";
import ReplyDate from "@/components/communityTalk/reply/ReplyDate.vue";
import CommunityTalkUser from "@/components/communityTalk/CommunityTalkUser.vue";
import ReplyNice from "@/components/communityTalk/reply/ReplyNice.vue";
import ReplyBestAnswerIcon from "@/components/communityTalk/reply/ReplyBestAnswerIcon.vue";
import ReplyTenantIcon from "@/components/communityTalk/reply/ReplyTenantIcon.vue";
import { ReplyDto } from "@/apiRequests/models/communityTalk/replyGetResponse";
import { CommunityTalkUserViewModel } from "@/viewModels/communityTalk/communityTalkUserViewModel";
import CommunityTalkMedia from "@/components/common/CommunityTalkMedia.vue";
import { LayoutTagGetResponse_WordSetting } from "@/apiRequests/models/communityTalk/layoutTagGetResponse";
import { CommunityTalkStore, isValidCommunityTalkStoreKey } from "@/store/communityTalk/communityTalkStore";

interface Props {
	/**
	 * リプライ情報。
	 */
	reply: ReplyDto;
	/**
	 * 表示タグ設定>文言設定。
	 */
	wordSettings: LayoutTagGetResponse_WordSetting;
	/**
	 * CommunityTalkStoreのInject用キー。
	 */
	communityTalkStoreKey: string;
	/**
	 * ReplyPostStoreのInject用キー。
	 */
	replyPostStoreKey: string;
}

export default /*#__PURE__*/_defineComponent({
  props: {
    reply: { type: null, required: true },
    wordSettings: { type: null, required: true },
    communityTalkStoreKey: { type: String, required: true },
    replyPostStoreKey: { type: String, required: true }
  },
  setup(__props: any, { expose }) {
  expose()

const props = __props as {
	/**
	 * リプライ情報。
	 */
	reply: ReplyDto;
	/**
	 * 表示タグ設定>文言設定。
	 */
	wordSettings: LayoutTagGetResponse_WordSetting;
	/**
	 * CommunityTalkStoreのInject用キー。
	 */
	communityTalkStoreKey: string;
	/**
	 * ReplyPostStoreのInject用キー。
	 */
	replyPostStoreKey: string;
}
/**
 * リプライ情報。
 */



const communityTalkUserViewModel: CommunityTalkUserViewModel = {
	badgeType: props.reply.badgeType,
	nickName: props.reply.nickName,
	profilePicUrl: props.reply.profilePicUrl,
	reviewerAttributeAnswers: props.reply.reviewerAttributeAnswers,
};

// Storeの初期化処理
if (!isValidCommunityTalkStoreKey(props.communityTalkStoreKey)) {
	// なんらかの原因でInjectKeyにエラーが発生していた場合は強制終了
	throw new Error(`InjectKeyにエラーが発生しました。${props.communityTalkStoreKey.toString()}`);
}
const communityTalkStore = inject(props.communityTalkStoreKey) as CommunityTalkStore;

const __returned__ = { props, communityTalkUserViewModel, communityTalkStore, ReplyContents, ReplyResponseButton, ReplyDate, CommunityTalkUser, ReplyNice, ReplyBestAnswerIcon, ReplyTenantIcon, CommunityTalkMedia }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})